import { render, staticRenderFns } from "./Devtools.vue?vue&type=template&id=1d4fcc2e&scoped=true&"
import script from "./Devtools.vue?vue&type=script&lang=js&"
export * from "./Devtools.vue?vue&type=script&lang=js&"
import style0 from "./Devtools.vue?vue&type=style&index=0&id=1d4fcc2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4fcc2e",
  null
  
)

export default component.exports